import { GridOptions } from 'ag-grid-community';
import { ColDef, TableQueryParams } from './table-ag-types';
import { suppressKeyboardEvent } from './table-ag-utils';

export const CheckBoxColID = 'CheckBox';

/**Các option default cho AG-GRID */
export const gridOptions: GridOptions<any> = {
    defaultColDef: {
        hide: false,
        cellClass: '!p-1.5',
        headerClass: '!px-1.5',
        resizable: true,
        flex: 1,
        autoHeaderHeight: true,
        autoHeight: true,
        unSortIcon: undefined,
        suppressKeyboardEvent: suppressKeyboardEvent,
        sortable: false,
        cellDataType: false,
    },

    suppressMoveWhenRowDragging: true,
    suppressHeaderFocus: true,
    enableCellTextSelection: true,
};

export const checkBoxCol: ColDef = {
    minWidth: 42,
    maxWidth: 42,
    cellClass: '!px-3',
    headerClass: '!px-3',
    lockVisible: true,
    colId: CheckBoxColID,
};

export const actionCol: ColDef = {
    minWidth: 80,
    maxWidth: 80,
    initialPinned: 'right',
};

export const initialPageInfo: TableQueryParams = {
    pageNumber: 1,
    pageSize: 10,
    isGetDeleted: false,
    sorts: [{ key: 'Created', value: 1 }],
};

export const initialPageResponse = {
    totalPage: 1,
    totalCount: 0,
};

export const pageSizeOptions = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
];
